import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "dc-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dc-card-header-defaut" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "dc-card-header-defaut-line" }),
    /*#__PURE__*/_createElementVNode("p", null, "异动详情")
  ])
], -1)


import { ref, watch, nextTick, onMounted } from 'vue'
import { followAlarmListGet } from '@/api/gucangSales/analysis'
import { FollowAlarmItem, FollowAlarmParams } from '@/typings/api/analysis'
import { alarmTypeEnum, alarmLevelEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { useVModel } from '@vueuse/core'
import { paramCodesDataFilter } from '@/utils/index'
import type { Rule } from 'ant-design-vue/es/form'
import { cloneDeep } from 'lodash-es'
const __default__ = { name: 'DcCosFbuAccountCode' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  cosId: {
    type: String,
    require: true
  },
  followId: {
    // 跟进记录id
    type: String
  },
  pageType: {
    type: String,
    default: 'add'
  },
  view: {
    type: Boolean
  },
  value: {
    type: Object,
    default: () => {
      return {}
    }
  },
  alarmHasMain: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:value', 'update:alarmHasMain'],
  setup(__props, { expose: __expose, emit: __emit }) {

const tableRef = ref()
const baseFormRef = ref()
const tableData = ref<FollowAlarmItem[]>([])
const resetData = ref<FollowAlarmItem[]>([])
const paramCodeData = ref<any>({
  fbu_change_description: [] // 异动说明
})
const props = __props
const emit = __emit
const hasMain = useVModel(props, 'alarmHasMain', emit)

const alarmLevelValidate = async (rule: Rule, value: string[], arkCode: string, index: number) => {
  let valueText = ''
  if (value && value.length) {
    valueText = findLabel(value).join()
    if (valueText.includes('未流失') && valueText.includes('已流失')) {
      return Promise.reject(new Error('未流失与已流失不可同时选择'))
    }
  }
  // 查找相同的客户代码
  let hasError = false
  const path = []
  let alarmDescTextValue = []
  for (let i = 0; i < tableData.value.length; i++) {
    const item = tableData.value[i]
    if (item.arkCode === arkCode && item.alarmDesc?.length) {
      alarmDescTextValue.push(...item.alarmDesc)
      path.push([i, 'alarmDesc'])
    }
  }
  alarmDescTextValue = findLabel(alarmDescTextValue).join()
  if (alarmDescTextValue.includes('未流失') && alarmDescTextValue.includes('已流失')) {
    hasError = true
  }
  if (hasError) {
    if (valueText.includes('未流失') || valueText.includes('已流失')) {
      return Promise.reject(new Error('未流失与已流失不可同时选择'))
    } else {
      return Promise.resolve()
    }
  } else {
    // 是否清空error
    path.length && baseFormRef.value.clearValidate(path)
  }
  return Promise.resolve()
}
// 查找label
const findLabel = (arr: any) => {
  if (Array.isArray(arr)) {
    const labelAry: any = []
    const { fbu_change_description } = paramCodeData.value
    arr.forEach((v) => {
      const find: any = fbu_change_description.find((item: any) => item.id === v)
      labelAry.push(find?.name)
    })
    return labelAry
  }
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_change_description']
  }).then((res) => {
    if (res.code === 200) {
      if (props.view) {
        paramCodeData.value = res.data
      } else {
        paramCodeData.value = paramCodesDataFilter(res.data, 0)
      }
    }
  })
}
onMounted(() => {
  getByParamCodes()
})
const columns = ref([
  {
    title: '子客户代码',
    dataIndex: 'arkCode'
  },
  {
    title: '异动触发时间',
    dataIndex: 'alarmDate'
  },
  {
    title: '异动类型',
    dataIndex: 'alarmType',
    dicData: alarmTypeEnum
  },
  {
    title: '异动级别',
    dataIndex: 'alarmLevel',
    dicData: alarmLevelEnum
  },
  {
    title: '异动原因',
    dataIndex: 'alarmInfo'
  },
  {
    title: '异动说明',
    dataIndex: 'alarmDesc'
  }
])
const fetch = () => {
  if (!props.cosId) {
    tableData.value = []
    return
  }
  let p: FollowAlarmParams = {
    cosId: props.cosId
  }
  if (props.followId) {
    p = {
      followId: props.followId
    }
  }
  followAlarmListGet(p).then((res) => {
    tableData.value = res.data
    resetData.value = cloneDeep(tableData.value)
    // 是否有一二级异动情况
    if (tableData.value && !hasMain.value) {
      const mainIndex = tableData.value.findIndex((item) => item.alarmLevel === 1 || item.alarmLevel === 2)
      if (mainIndex !== -1) {
        hasMain.value = true
      }
    }
  })
}
watch(
  () => props.cosId,
  (v) => {
    hasMain.value = false
    fetch()
  }
)
// 处理
const validate = () => {
  return new Promise((resolve, reject) => {
    baseFormRef.value
      ?.validate()
      .then(async () => {
        const result: any[] = []
        tableData.value.forEach((item: FollowAlarmItem) => {
          result.push({
            alarmDesc: item.alarmDesc,
            alarmDescText: item.alarmDescText,
            alarmId: item.alarmId,
            arkCode: item.arkCode
          })
        })
        emit('update:value', {
          batch: result
        })
        resolve(result)
      })
      .catch((err: any) => {
        reject(err)
      })
  })
}
const reset = () => {
  tableData.value = cloneDeep(resetData.value)
  nextTick(() => {
    baseFormRef.value.clearValidate()
  })
}

__expose({ validate, reset })

return (_ctx: any,_cache: any) => {
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_a_form = _resolveComponent("a-form")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_a_form, {
      name: "detailsForm",
      ref_key: "baseFormRef",
      ref: baseFormRef,
      model: tableData.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_cos_table, {
          columns: columns.value,
          dataSource: tableData.value,
          needPage: false,
          ref_key: "tableRef",
          ref: tableRef,
          tableId: "fbuFollowBaseAlarm"
        }, {
          bodyCell: _withCtx(({ column, index, record }) => [
            (column.dataIndex === 'alarmDesc')
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  name: [index, 'alarmDesc'],
                  rules: [
                {
                  required: record.alarmLevel === 1 || record.alarmLevel === 2 ? true : false,
                  message: '请选择'
                },
                {
                  validator: (rule, value) => alarmLevelValidate(rule, value, record.arkCode, index)
                }
              ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      options: paramCodeData.value.fbu_change_description,
                      value: tableData.value[index].alarmDesc,
                      "onUpdate:value": ($event: any) => ((tableData.value[index].alarmDesc) = $event),
                      label: tableData.value[index].alarmDescText,
                      "onUpdate:label": ($event: any) => ((tableData.value[index].alarmDescText) = $event),
                      mode: "multiple",
                      view: __props.view
                    }, null, 8, ["options", "value", "onUpdate:value", "label", "onUpdate:label", "view"])
                  ]),
                  _: 2
                }, 1032, ["name", "rules"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "dataSource"])
      ]),
      _: 1
    }, 8, ["model"])
  ], 512)), [
    [_vShow, tableData.value && tableData.value.length]
  ])
}
}

})